import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { AutoComplete } from 'primereact/autocomplete';
import acordLogo from 'images/acordlogo.png';
import CreateNewCarriers from '../CreateNewCarriers';
import AddNewSignature from '../AddNewSignature';
import { useSignatures } from '../../../../hooks/useSignatures';
import ProducerSection, { fetchPolicyAgentContact } from '../ProducerSection';
import { useCertificateHolders } from '../../../certificate-holders/hooks/useCertificateHolders';
import InsurerSearchDropdown from '../InsurerSearchDropdown';
import { formatUsPhone } from 'utilities/formatPhone';

const INSR_OPTIONS = ['A','B','C','D','E','F'].map(l => ({ label: l, value: l }));

interface Acord30FormProps { selectedPolicies?: string[]; insuredId?: string; }

export default function Acord30Form({ selectedPolicies = [], insuredId = '' }: Acord30FormProps) {
  const [showCreateCarrier, setShowCreateCarrier] = React.useState(false);
  const [showAddSignature, setShowAddSignature] = React.useState(false);
  const [producerAddress, setProducerAddress] = React.useState('');
  const [producerCity, setProducerCity] = React.useState('');
  const [producerState, setProducerState] = React.useState('');
  const [producerZip, setProducerZip] = React.useState('');
  const [producerStreet, setProducerStreet] = React.useState('');
  const [contactName, setContactName] = React.useState('');
  const [contactPhone, setContactPhone] = React.useState('');
  const [contactFax, setContactFax] = React.useState('');
  const [contactEmail, setContactEmail] = React.useState('');
  const [insuredName, setInsuredName] = React.useState('');
  const [insuredAddress, setInsuredAddress] = React.useState('');
  const [insuredCity, setInsuredCity] = React.useState('');
  const [insuredState, setInsuredState] = React.useState('');
  const [insuredZip, setInsuredZip] = React.useState('');
  const [insurerA, setInsurerA] = React.useState('');
  const [insurerB, setInsurerB] = React.useState('');
  const [insurerC, setInsurerC] = React.useState('');
  const [insurerD, setInsurerD] = React.useState('');
  const [insurerE, setInsurerE] = React.useState('');
  const [certDate, setCertDate] = React.useState<Date | null>(new Date());
  const [prodCustomerId, setProdCustomerId] = React.useState('');
  const [certNumber, setCertNumber] = React.useState('');
  const [revisionNumber, setRevisionNumber] = React.useState('');
  const [glAnyAuto, setGlAnyAuto] = React.useState(false);
  const [glAllOwned, setGlAllOwned] = React.useState(false);
  const [glHiredOnly, setGlHiredOnly] = React.useState(false);
  const [glNonOwnedGarage, setGlNonOwnedGarage] = React.useState(false);
  const [glOtherCheck, setGlOtherCheck] = React.useState(false);
  const [glOtherText, setGlOtherText] = React.useState('');
  const [glPolicyNumber, setGlPolicyNumber] = React.useState('');
  const [glEffDate, setGlEffDate] = React.useState<Date | null>(null);
  const [glExpDate, setGlExpDate] = React.useState<Date | null>(null);
  const [glAutoOnly, setGlAutoOnly] = React.useState('');
  const [glEaAccident, setGlEaAccident] = React.useState('');
  const [glAggregate, setGlAggregate] = React.useState('');
  const [gkLegalLiability, setGkLegalLiability] = React.useState(false);
  const [gkDirectBasis, setGkDirectBasis] = React.useState(false);
  const [gkPrimary, setGkPrimary] = React.useState(false);
  const [gkExcess, setGkExcess] = React.useState(false);
  const [gkPolicyNumber, setGkPolicyNumber] = React.useState('');
  const [gkEffDate, setGkEffDate] = React.useState<Date | null>(null);
  const [gkExpDate, setGkExpDate] = React.useState<Date | null>(null);
  const [gkCompOtc, setGkCompOtc] = React.useState(false);
  const [gkCompOtcLimit, setGkCompOtcLimit] = React.useState('');
  const [gkSpecifiedPerils, setGkSpecifiedPerils] = React.useState(false);
  const [gkSpecifiedPerilsLimit, setGkSpecifiedPerilsLimit] = React.useState('');
  const [gkCollision, setGkCollision] = React.useState(false);
  const [gkCollisionLimit, setGkCollisionLimit] = React.useState('');
  const [gkOtherLimit, setGkOtherLimit] = React.useState('');

  const [cglClaimsMade, setCglClaimsMade] = React.useState(false);
  const [cglOccur, setCglOccur] = React.useState(false);
  const [cglOtherCheck, setCglOtherCheck] = React.useState(false);
  const [cglOtherText, setCglOtherText] = React.useState('');
  const [cglPolicy, setCglPolicy] = React.useState(false);
  const [cglProject, setCglProject] = React.useState(false);
  const [cglLoc, setCglLoc] = React.useState(false);
  const [cglOtherAgg, setCglOtherAgg] = React.useState(false);
  const [cglOtherAggText, setCglOtherAggText] = React.useState('');
  const [cglPolicyNumber, setCglPolicyNumber] = React.useState('');
  const [cglEffDate, setCglEffDate] = React.useState<Date | null>(null);
  const [cglExpDate, setCglExpDate] = React.useState<Date | null>(null);
  const [cglEachOccurrence, setCglEachOccurrence] = React.useState('');
  const [cglDamageRented, setCglDamageRented] = React.useState('');
  const [cglMedExp, setCglMedExp] = React.useState('');
  const [cglPersonalAdv, setCglPersonalAdv] = React.useState('');
  const [cglGeneralAgg, setCglGeneralAgg] = React.useState('');
  const [cglProductsAgg, setCglProductsAgg] = React.useState('');
  const [cglExtraLimit, setCglExtraLimit] = React.useState('');
  const [umbrellaLiab, setUmbrellaLiab] = React.useState(false);
  const [umbrellaOccur, setUmbrellaOccur] = React.useState(false);
  const [excessLiab, setExcessLiab] = React.useState(false);
  const [umbrellaClaimsMade, setUmbrellaClaimsMade] = React.useState(false);
  const [umbrellaDed, setUmbrellaDed] = React.useState(false);
  const [umbrellaRetention, setUmbrellaRetention] = React.useState(false);
  const [umbrellaRetentionAmt, setUmbrellaRetentionAmt] = React.useState('');
  const [umbrellaPolicyNumber, setUmbrellaPolicyNumber] = React.useState('');
  const [umbrellaEffDate, setUmbrellaEffDate] = React.useState<Date | null>(null);
  const [umbrellaExpDate, setUmbrellaExpDate] = React.useState<Date | null>(null);
  const [umbrellaEachOcc, setUmbrellaEachOcc] = React.useState('');
  const [umbrellaAggregate, setUmbrellaAggregate] = React.useState('');
  const [umbrellaExtraLimit, setUmbrellaExtraLimit] = React.useState('');
  const [wcPolicyNumber, setWcPolicyNumber] = React.useState('');
  const [wcEffDate, setWcEffDate] = React.useState<Date | null>(null);
  const [wcExpDate, setWcExpDate] = React.useState<Date | null>(null);
  const [wcPerStatute, setWcPerStatute] = React.useState(false);
  const [wcOther, setWcOther] = React.useState(false);
  const [wcYN, setWcYN] = React.useState('');
  const [wcEachAccident, setWcEachAccident] = React.useState('');
  const [wcDiseaseEmployee, setWcDiseaseEmployee] = React.useState('');
  const [wcDiseasePolicyLimit, setWcDiseasePolicyLimit] = React.useState('');
  const [otherType, setOtherType] = React.useState('');
  const [otherPolicyNumber, setOtherPolicyNumber] = React.useState('');
  const [otherEffDate, setOtherEffDate] = React.useState<Date | null>(null);
  const [otherExpDate, setOtherExpDate] = React.useState<Date | null>(null);
  const [otherLim1, setOtherLim1] = React.useState('');
  const [otherLim2, setOtherLim2] = React.useState('');
  const [remarks, setRemarks] = React.useState('');
  const [holderName, setHolderName] = React.useState('');
  const [holderAddress, setHolderAddress] = React.useState('');
  const [holderCity, setHolderCity] = React.useState('');
  const [holderState, setHolderState] = React.useState('');
  const [holderZip, setHolderZip] = React.useState('');
  const [holderSearchQuery, setHolderSearchQuery] = React.useState('');
  const { holders: holderSuggestions } = useCertificateHolders(holderSearchQuery, 10);

  const [authRepSignature, setAuthRepSignature] = React.useState('');
  const { signatureOptions, refetchSignatures } = useSignatures();
  const [signaturePreviewUrl, setSignaturePreviewUrl] = React.useState('');
  React.useEffect(() => {
    if (!authRepSignature) { setSignaturePreviewUrl(''); return; }
    fetch(`${process.env.REACT_APP_COIPortal_Url}/api/igigcoi/signature-preview/${authRepSignature}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('igtoken') || ''}`,
        'Content-Type': 'application/json',
        NCToken: localStorage.getItem('NCToken') || '',
      },
    })
      .then(r => r.ok ? r.text() : Promise.reject())
      .then(url => setSignaturePreviewUrl(url.replace(/^"|"$/g, '')))
      .catch(() => setSignaturePreviewUrl(''));
  }, [authRepSignature]);

  React.useEffect(() => {
    if (!selectedPolicies || selectedPolicies.length === 0) return;
    let cancelled = false;
    const fetchCoverages = async () => {
      try {
        const ncToken = localStorage.getItem('NCToken') || '';
        const igToken = localStorage.getItem('igtoken') || '';
        const res = await fetch(
          `${process.env.REACT_APP_COIPortal_Url}/api/IGIGCOI/get-coverages`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'NCToken': ncToken,
              Authorization: `Bearer ${igToken}`,
            },
            body: JSON.stringify({
              policiesIds: selectedPolicies,
              truckingCompanyId: insuredId || '',
              fileParentId: '07E4167D-FB1D-493D-994F-0785EF2237B4',
              naics: [{ Code: '', Name: '' }],
              Page: 'certificateFiller',
            }),
          }
        );
        if (cancelled) return;
        await res.json();
      } catch {
        // silently fail — user can still fill manually
      }
    };
    fetchCoverages();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPolicies, insuredId]);

  // Prefill contact section from the first selected policy's agent
  React.useEffect(() => {
    if (!selectedPolicies || selectedPolicies.length === 0) return;
    fetchPolicyAgentContact(selectedPolicies[0]).then(({ name, phone, fax, email }) => {
      if (name) setContactName(name);
      if (phone) setContactPhone(phone);
      if (fax) setContactFax(fax);
      if (email) setContactEmail(email);
    });
  }, [selectedPolicies]);

  return (
    <>
      <div className="masterCert__section">
        {/* ACORD HEADER */}
        <div className="masterCert__acordHeader">
          <img src={acordLogo} alt="ACORD" className="masterCert__acordLogo" />
          <div className="masterCert__acordTitleWrapper">
            <div className="masterCert__acordTitle">CERTIFICATE OF GARAGE INSURANCE</div>
          </div>
          <div className="masterCert__dateWrapper">
            <div className="masterCert__dateLabel">DATE (MM/DD/YYYY)</div>
            <div className="masterCert__dateCell">
              <Calendar value={certDate} onChange={(e) => setCertDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
          </div>
        </div>

        {/* DISCLAIMER */}
        <div className="masterCert__disclaimer">
          This certificate is issued as a matter of information only and confers no rights upon the certificate holder. This certificate does not affirmatively or negatively amend, extend or alter the coverage afforded by the policies below. This certificate of insurance does not constitute a contract between the issuing insurer(s), authorized representative or producer, and the certificate holder.
        </div>
        <div className="masterCert__disclaimerImportant">
          <span className="masterCert__importantLabel">IMPORTANT:</span> If the certificate holder is an ADDITIONAL INSURED, the policy(ies) must be endorsed. If SUBROGATION IS WAIVED, subject to the terms and conditions of the policy, certain policies may require an endorsement. A statement on this certificate does not confer rights to the certificate holder in lieu of such endorsement(s).
        </div>

        {/* PRODUCER & CONTACT / INSURED & INSURERS */}
        <div className="masterCert__twoColumnLayout">
          {/* LEFT COLUMN */}
          <div>
            <ProducerSection
              address={producerAddress}
              onAddressChange={setProducerAddress}
              city={producerCity}
              onCityChange={setProducerCity}
              street={producerStreet}
              onStreetChange={setProducerStreet}
              state={producerState}
              onStateChange={setProducerState}
              zip={producerZip}
              onZipChange={setProducerZip}
              onAgentContact={(phone, fax, email) => { setContactPhone(phone); setContactFax(fax); setContactEmail(email); }}
              readOnly
            />
            <div>
              <div className="masterCert__sectionHeader">INSURED</div>
              <Dropdown value={insuredName} onChange={(e) => setInsuredName(e.value)} options={[]} placeholder="Type and/or choose location" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" editable disabled emptyMessage="No available options" />
              <InputText maxLength={100} value={insuredAddress} onChange={(e) => setInsuredAddress(e.target.value)} placeholder="Address" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" readOnly />
              <div className="masterCert__addressGrid">
                <InputText maxLength={100} value={insuredCity} onChange={(e) => setInsuredCity(e.target.value)} placeholder="City" className="masterCert__input masterCert__inputFull" readOnly />
                <InputText maxLength={50} value={insuredState} onChange={(e) => setInsuredState(e.target.value)} placeholder="State" className="masterCert__input masterCert__inputFull" readOnly />
                <InputText maxLength={20} value={insuredZip} onChange={(e) => setInsuredZip(e.target.value)} placeholder="Zip" className="masterCert__input masterCert__inputFull" readOnly />
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div>
            <div style={{ marginBottom: 16 }}>
              <div className="masterCert__contactGrid">
                <div>
                  <div className="masterCert__contactLabel">CONTACT NAME:</div>
                  <InputText maxLength={100} value={contactName} onChange={(e) => setContactName(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
                <div></div>
              </div>
              <div className="masterCert__contactGrid">
                <div>
                  <div className="masterCert__contactLabel">PHONE (A/C, No, Ext):</div>
                  <InputText value={formatUsPhone(contactPhone)} onChange={(e) => setContactPhone(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
                <div>
                  <div className="masterCert__contactLabel">FAX (A/C, No):</div>
                  <InputText value={formatUsPhone(contactFax)} onChange={(e) => setContactFax(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
              </div>
              <div>
                <div className="masterCert__contactLabel">E-MAIL ADDRESS:</div>
                <InputText maxLength={100} value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
              </div>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
                <div className="masterCert__sectionHeader" style={{ marginBottom: 0 }}>INSURERS AFFORDING COVERAGE (and NAIC #)</div>
                <Button className="carrierDialog__secondaryBtn" label="Add New" icon="pi pi-plus" outlined size="small" style={{ flexShrink: 0, padding: '2px 10px', fontSize: '0.7rem', height: '28px' }} onClick={() => setShowCreateCarrier(true)} />
              </div>
              <div className="masterCert__insurersGrid">
                <div className="masterCert__insurerLabel">INSURER A:</div>
                <InsurerSearchDropdown value={insurerA} onChange={setInsurerA} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER B:</div>
                <InsurerSearchDropdown value={insurerB} onChange={setInsurerB} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER C:</div>
                <InsurerSearchDropdown value={insurerC} onChange={setInsurerC} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER D:</div>
                <InsurerSearchDropdown value={insurerD} onChange={setInsurerD} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER E:</div>
                <InsurerSearchDropdown value={insurerE} onChange={setInsurerE} className="masterCert__input masterCert__inputFull" />
              </div>
            </div>
          </div>
        </div>

        {/* ═══ COVERAGES ═══ */}
        <div className="masterCert__coveragesSection">
          <div className="masterCert__coveragesTitle">COVERAGES</div>

          {/* PROD / CUSTOMER ID, CERT #, REVISION # */}
          <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1 }}>
              <div className="masterCert__contactLabel" style={{ whiteSpace: 'nowrap' }}>PROD / CUSTOMER ID:</div>
              <InputText maxLength={30} value={prodCustomerId} onChange={(e) => setProdCustomerId(e.target.value)} className="masterCert__input masterCert__inputFull" />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1 }}>
              <div className="masterCert__contactLabel" style={{ whiteSpace: 'nowrap' }}>CERTIFICATE #:</div>
              <InputText maxLength={30} value={certNumber} onChange={(e) => setCertNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1 }}>
              <div className="masterCert__contactLabel" style={{ whiteSpace: 'nowrap' }}>REVISION #:</div>
              <InputText maxLength={30} value={revisionNumber} onChange={(e) => setRevisionNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            </div>
          </div>

          <div className="masterCert__disclaimer" style={{ marginBottom: 12 }}>
            This is to certify that the policies of insurance listed below have been issued to the insured names above for the policy period indicated. Notwithstanding any requirement, term or condition of any contract or other document with respect to which this certificate may be issued or may pertain, the insurance afforded by the policies described herein is subject to all the terms, exclusions and conditions of such policies. Limits shown may have been reduced by paid claims.
          </div>

          {/* Coverage Table Header */}
          <div className="masterCert__coverageHeader">
            <div>INSR<br/>LTR</div>
            <div>TYPE OF INSURANCE</div>
            <div>POLICY NUMBER</div>
            <div className="masterCert__coverageHeaderCenter">POLICY EFFECTIVE<br/>DATE (MM/DD/YY)</div>
            <div className="masterCert__coverageHeaderCenter">POLICY EXPIRATION<br/>DATE (MM/DD/YY)</div>
            <div>LIMITS</div>
          </div>

          {/* ── GARAGE LIABILITY ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__coverageType">GARAGE LIABILITY</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="glAnyAuto" checked={glAnyAuto} onChange={(e) => setGlAnyAuto(e.checked ?? false)} />
                <label htmlFor="glAnyAuto" className="masterCert__checkboxItemLabel">ANY AUTO</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="glAllOwned" checked={glAllOwned} onChange={(e) => setGlAllOwned(e.checked ?? false)} />
                <label htmlFor="glAllOwned" className="masterCert__checkboxItemLabel">ALL OWNED AUTOS</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="glHiredOnly" checked={glHiredOnly} onChange={(e) => setGlHiredOnly(e.checked ?? false)} />
                <label htmlFor="glHiredOnly" className="masterCert__checkboxItemLabel">HIRED AUTOS ONLY</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="glNonOwnedGarage" checked={glNonOwnedGarage} onChange={(e) => setGlNonOwnedGarage(e.checked ?? false)} />
                <label htmlFor="glNonOwnedGarage" className="masterCert__checkboxItemLabel">NON-OWNED AUTOS USED IN GARAGE BUSINESS</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="glOtherCheck" checked={glOtherCheck} onChange={(e) => setGlOtherCheck(e.checked ?? false)} />
                <InputText value={glOtherText} onChange={(e) => setGlOtherText(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <InputText maxLength={50} value={glPolicyNumber} onChange={(e) => setGlPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={glEffDate} onChange={(e) => setGlEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={glExpDate} onChange={(e) => setGlExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__limitLabel">AUTO ONLY (Ea accident)</div>
              <InputText value={glAutoOnly} onChange={(e) => setGlAutoOnly(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">OTHER THAN<br/>AUTO ONLY</div>
              <InputText placeholder="$" className="masterCert__input masterCert__limitInput" disabled />
              <div className="masterCert__limitLabel" style={{ paddingLeft: 8 }}>EA ACCIDENT</div>
              <InputText value={glEaAccident} onChange={(e) => setGlEaAccident(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel" style={{ paddingLeft: 8 }}>AGGREGATE</div>
              <InputText value={glAggregate} onChange={(e) => setGlAggregate(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── GARAGE KEEPERS LIABILITY ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__coverageType">GARAGE KEEPERS LIABILITY</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="gkLegalLiability" checked={gkLegalLiability} onChange={(e) => setGkLegalLiability(e.checked ?? false)} />
                <label htmlFor="gkLegalLiability" className="masterCert__checkboxItemLabel">LEGAL LIABILITY</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="gkDirectBasis" checked={gkDirectBasis} onChange={(e) => setGkDirectBasis(e.checked ?? false)} />
                <label htmlFor="gkDirectBasis" className="masterCert__checkboxItemLabel">DIRECT BASIS</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="gkPrimary" checked={gkPrimary} onChange={(e) => setGkPrimary(e.checked ?? false)} />
                <label htmlFor="gkPrimary" className="masterCert__checkboxItemLabel">PRIMARY</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="gkExcess" checked={gkExcess} onChange={(e) => setGkExcess(e.checked ?? false)} />
                <label htmlFor="gkExcess" className="masterCert__checkboxItemLabel">EXCESS</label>
              </div>
            </div>
            <InputText maxLength={50} value={gkPolicyNumber} onChange={(e) => setGkPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={gkEffDate} onChange={(e) => setGkEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={gkExpDate} onChange={(e) => setGkExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="gkCompOtc" checked={gkCompOtc} onChange={(e) => setGkCompOtc(e.checked ?? false)} />
                <label htmlFor="gkCompOtc" className="masterCert__checkboxItemLabel">COMP/OTC</label>
              </div>
              <InputText value={gkCompOtcLimit} onChange={(e) => setGkCompOtcLimit(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="gkSpecPerils" checked={gkSpecifiedPerils} onChange={(e) => setGkSpecifiedPerils(e.checked ?? false)} />
                <label htmlFor="gkSpecPerils" className="masterCert__checkboxItemLabel">SPECIFIED PERILS</label>
              </div>
              <InputText value={gkSpecifiedPerilsLimit} onChange={(e) => setGkSpecifiedPerilsLimit(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="gkCollision" checked={gkCollision} onChange={(e) => setGkCollision(e.checked ?? false)} />
                <label htmlFor="gkCollision" className="masterCert__checkboxItemLabel">COLLISION</label>
              </div>
              <InputText value={gkCollisionLimit} onChange={(e) => setGkCollisionLimit(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel"></div>
              <InputText value={gkOtherLimit} onChange={(e) => setGkOtherLimit(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── COMMERCIAL GENERAL LIABILITY ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__coverageType">COMMERCIAL GENERAL LIABILITY</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30CglClaimsMade" checked={cglClaimsMade} onChange={(e) => setCglClaimsMade(e.checked ?? false)} />
                <label htmlFor="a30CglClaimsMade" className="masterCert__checkboxItemLabel">CLAIMS-MADE</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30CglOccur" checked={cglOccur} onChange={(e) => setCglOccur(e.checked ?? false)} />
                <label htmlFor="a30CglOccur" className="masterCert__checkboxItemLabel">OCCUR</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30CglOther" checked={cglOtherCheck} onChange={(e) => setCglOtherCheck(e.checked ?? false)} />
                <InputText value={cglOtherText} onChange={(e) => setCglOtherText(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
              <div className="masterCert__coverageTypeAlt">GEN'L AGGREGATE LIMIT APPLIES PER:</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30CglPolicy" checked={cglPolicy} onChange={(e) => setCglPolicy(e.checked ?? false)} />
                <label htmlFor="a30CglPolicy" className="masterCert__checkboxItemLabel">POLICY</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30CglProject" checked={cglProject} onChange={(e) => setCglProject(e.checked ?? false)} />
                <label htmlFor="a30CglProject" className="masterCert__checkboxItemLabel">PROJECT</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30CglLoc" checked={cglLoc} onChange={(e) => setCglLoc(e.checked ?? false)} />
                <label htmlFor="a30CglLoc" className="masterCert__checkboxItemLabel">LOC</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30CglOtherAgg" checked={cglOtherAgg} onChange={(e) => setCglOtherAgg(e.checked ?? false)} />
                <label htmlFor="a30CglOtherAgg" className="masterCert__checkboxItemLabel">OTHER:</label>
                <InputText value={cglOtherAggText} onChange={(e) => setCglOtherAggText(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <InputText maxLength={50} value={cglPolicyNumber} onChange={(e) => setCglPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={cglEffDate} onChange={(e) => setCglEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={cglExpDate} onChange={(e) => setCglExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__limitLabel">EACH OCCURRENCE</div>
              <InputText value={cglEachOccurrence} onChange={(e) => setCglEachOccurrence(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">DAMAGE TO RENTED<br/>PREMISES (Ea occurrence)</div>
              <InputText value={cglDamageRented} onChange={(e) => setCglDamageRented(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">MED EXP (Any one person)</div>
              <InputText value={cglMedExp} onChange={(e) => setCglMedExp(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">PERSONAL &amp; ADV INJURY</div>
              <InputText value={cglPersonalAdv} onChange={(e) => setCglPersonalAdv(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">GENERAL AGGREGATE</div>
              <InputText value={cglGeneralAgg} onChange={(e) => setCglGeneralAgg(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">PRODUCTS COMP/OP AGG</div>
              <InputText value={cglProductsAgg} onChange={(e) => setCglProductsAgg(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <InputText value={cglExtraLimit} onChange={(e) => setCglExtraLimit(e.target.value)} className="masterCert__input masterCert__limitInput" />
              <InputText placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── UMBRELLA / EXCESS LIABILITY ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30UmbrellaLiab" checked={umbrellaLiab} onChange={(e) => setUmbrellaLiab(e.checked ?? false)} />
                <label htmlFor="a30UmbrellaLiab" className="masterCert__coverageType" style={{ marginLeft: 4 }}>UMBRELLA LIAB</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30UmbrellaOccur" checked={umbrellaOccur} onChange={(e) => setUmbrellaOccur(e.checked ?? false)} />
                <label htmlFor="a30UmbrellaOccur" className="masterCert__checkboxItemLabel">OCCUR</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30ExcessLiab" checked={excessLiab} onChange={(e) => setExcessLiab(e.checked ?? false)} />
                <label htmlFor="a30ExcessLiab" className="masterCert__coverageType" style={{ marginLeft: 4 }}>EXCESS LIAB</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30UmbrellaClaimsMade" checked={umbrellaClaimsMade} onChange={(e) => setUmbrellaClaimsMade(e.checked ?? false)} />
                <label htmlFor="a30UmbrellaClaimsMade" className="masterCert__checkboxItemLabel">CLAIMS-MADE</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30UmbrellaDed" checked={umbrellaDed} onChange={(e) => setUmbrellaDed(e.checked ?? false)} />
                <label htmlFor="a30UmbrellaDed" className="masterCert__checkboxItemLabel">DED</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30UmbrellaRetention" checked={umbrellaRetention} onChange={(e) => setUmbrellaRetention(e.checked ?? false)} />
                <label className="masterCert__checkboxItemLabel">RETENTION $</label>
                <InputText value={umbrellaRetentionAmt} onChange={(e) => setUmbrellaRetentionAmt(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <InputText maxLength={50} value={umbrellaPolicyNumber} onChange={(e) => setUmbrellaPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={umbrellaEffDate} onChange={(e) => setUmbrellaEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={umbrellaExpDate} onChange={(e) => setUmbrellaExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__limitLabel">EACH OCCURRENCE</div>
              <InputText value={umbrellaEachOcc} onChange={(e) => setUmbrellaEachOcc(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">AGGREGATE</div>
              <InputText value={umbrellaAggregate} onChange={(e) => setUmbrellaAggregate(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <InputText value={umbrellaExtraLimit} onChange={(e) => setUmbrellaExtraLimit(e.target.value)} className="masterCert__input masterCert__limitInput" />
              <InputText placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── WORKERS COMPENSATION ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__coverageType">WORKERS COMPENSATIONS AND EMPLOYERS' LIABILITY</div>
              <div className="masterCert__wcNote">ANY PROPRIETOR / PARTNER / EXECUTIVE<br/>OFFICER / MEMBER EXCLUDED?</div>
              <div className="masterCert__wcNote">(Mandatory in NH)</div>
              <div className="masterCert__wcNote">If yes, describe under REMARKS below</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.75rem' }}>
                <span>Y/N</span>
                <InputText value={wcYN} onChange={(e) => setWcYN(e.target.value)} className="masterCert__input" style={{ width: 40 }} />
              </div>
            </div>
            <InputText maxLength={50} value={wcPolicyNumber} onChange={(e) => setWcPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={wcEffDate} onChange={(e) => setWcEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={wcExpDate} onChange={(e) => setWcExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30WcPerStatute" checked={wcPerStatute} onChange={(e) => setWcPerStatute(e.checked ?? false)} />
                <label htmlFor="a30WcPerStatute" className="masterCert__checkboxItemLabel">PER STATUTE</label>
              </div>
              <InputText placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a30WcOther" checked={wcOther} onChange={(e) => setWcOther(e.checked ?? false)} />
                <label htmlFor="a30WcOther" className="masterCert__checkboxItemLabel">OTHER</label>
              </div>
              <InputText placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">E.L. EACH ACCIDENT</div>
              <InputText value={wcEachAccident} onChange={(e) => setWcEachAccident(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">E.L. DISEASE - EA EMPLOYEE</div>
              <InputText value={wcDiseaseEmployee} onChange={(e) => setWcDiseaseEmployee(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">E.L. DISEASE - POLICY LIMIT</div>
              <InputText value={wcDiseasePolicyLimit} onChange={(e) => setWcDiseasePolicyLimit(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── OTHER ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <InputText maxLength={100} value={otherType} onChange={(e) => setOtherType(e.target.value)} placeholder="Type of insurance" className="masterCert__input masterCert__inputFull" />
            </div>
            <InputText maxLength={50} value={otherPolicyNumber} onChange={(e) => setOtherPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={otherEffDate} onChange={(e) => setOtherEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={otherExpDate} onChange={(e) => setOtherExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__limitLabel"></div>
              <InputText value={otherLim1} onChange={(e) => setOtherLim1(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel"></div>
              <InputText value={otherLim2} onChange={(e) => setOtherLim2(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>
        </div>

        {/* REMARKS */}
        <div className="masterCert__descriptionSection">
          <div className="masterCert__descriptionTitle">REMARKS (Attach Acord 101, Additional Remarks Schedule, if more space is required)</div>
          <InputTextarea maxLength={2000} value={remarks} onChange={(e) => setRemarks(e.target.value)} rows={4} className="masterCert__descriptionTextarea" />
        </div>

        {/* CERTIFICATE HOLDER & CANCELLATION */}
        <div className="masterCert__bottomRow">
          <div className="masterCert__certHolderBox">
            <div className="masterCert__sectionHeader">CERTIFICATE HOLDER</div>
            <div style={{ position: 'relative', width: '100%', marginBottom: 6 }}>
              <i className="pi pi-search" style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: 13, zIndex: 1, pointerEvents: 'none' }} />
              <AutoComplete
                value={holderSearchQuery}
                suggestions={holderSuggestions.map((h) => ({ label: h.name, value: h }))}
                completeMethod={(e) => setHolderSearchQuery(e.query)}
                onChange={(e) => { if (typeof e.value === 'string') setHolderSearchQuery(e.value); }}
                field="label"
                placeholder="Search for a certificate holder"
                style={{ width: '100%' }}
                inputStyle={{ width: '100%', paddingLeft: 30 }}
                disabled
                onSelect={(e) => {
                  const h = e.value.value;
                  setHolderName(h.name || '');
                  setHolderAddress(h.addressLine1 || '');
                  setHolderCity(h.city || '');
                  setHolderState(h.stateName || '');
                  setHolderZip(h.zipCode || '');
                  setHolderSearchQuery('');
                }}
              />
            </div>
            <InputText maxLength={100} value={holderName} onChange={(e) => setHolderName(e.target.value)} placeholder="Name" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" disabled />
            <InputText maxLength={100} value={holderAddress} onChange={(e) => setHolderAddress(e.target.value)} placeholder="Address" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" disabled />
            <InputText maxLength={100} value={holderCity} onChange={(e) => setHolderCity(e.target.value)} placeholder="City" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" disabled />
            <div className="masterCert__addressGrid">
              <InputText placeholder="Street" className="masterCert__input masterCert__inputFull" disabled />
              <InputText maxLength={50} value={holderState} onChange={(e) => setHolderState(e.target.value)} placeholder="State" className="masterCert__input masterCert__inputFull" disabled />
              <InputText maxLength={20} value={holderZip} onChange={(e) => setHolderZip(e.target.value)} placeholder="Zip" className="masterCert__input masterCert__inputFull" disabled />
            </div>
          </div>
          <div className="masterCert__cancellationBox">
            <div className="masterCert__sectionHeader">CANCELLATION</div>
            <div className="masterCert__cancellationText">
              SHOULD ANY OF THE ABOVE DESCRIBED POLICIES BE CANCELLED BEFORE THE EXPIRATION DATE THEREOF, NOTICE WILL BE DELIVERED IN ACCORDANCE WITH THE POLICY PROVISIONS.
            </div>
            <div className="masterCert__authRepLabel">AUTHORIZED REPRESENTATIVE</div>
            <div className="masterCert__authRepRow">
              <Dropdown value={authRepSignature} onChange={(e) => setAuthRepSignature(e.value)} options={signatureOptions} optionLabel="label" optionValue="value" placeholder="Select signature:" className="masterCert__input masterCert__authRepDropdown" emptyMessage="No available options" />
              <Button label="Create New" className="p-button-outlined carrierDialog__secondaryBtn" onClick={() => setShowAddSignature(true)} />
            </div>
              {signaturePreviewUrl && (
                <div style={{ marginTop: 8 }}>
                  <img src={signaturePreviewUrl} alt="Signature preview" style={{ maxHeight: 60, maxWidth: 280, objectFit: 'contain', border: '1px solid #e5e7eb', borderRadius: 6, padding: '4px 8px', background: '#fff' }} />
                </div>
              )}
          </div>
        </div>

        {/* ACORD Footer */}
        <div className="masterCert__acordFooter">
          <div>ACORD 30 (2016/03)</div>
          <div>&copy; 2010-2015 ACORD CORPORATION. All rights reserved.</div>
        </div>
      </div>

      <CreateNewCarriers open={showCreateCarrier} onClose={() => setShowCreateCarrier(false)} />
      <AddNewSignature open={showAddSignature} onClose={() => setShowAddSignature(false)} onSaved={refetchSignatures} />
    </>
  );
}
